import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User, UserDetails } from 'src/app/models/authData';
import { AuthService } from 'src/app/services/auth.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { LeadsService } from 'src/app/services/super-admin/leads.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements  OnInit {

  userName: any;
  password: any;
  errorMessage = '';
  showError = false;
  rememberMeFlag: boolean = true;
  showPassword: boolean = false;
  showPasswordError: boolean = false;
  showUserNameError: boolean = false;
  private readonly FILTER_STORAGE_KEY = 'careerFilterState';
  private readonly SEARCH_STORAGE_KEY = 'careerSearchState';

  user: User = { email: '', password: '' } as User;
  constructor(
    private http: HttpClient,
    private router: Router, 
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private spinnerService: SpinnerService,
    private leadService: LeadsService,
    private sharedService: SharedService) { }

  ngOnChanges() {
    this.showError = false;
    this.errorMessage = '';
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      const accountName=this.localStorageService.getItem('accountName');
      if(accountName=='Staff'){
        this.authService.navigateStaff(this.localStorageService.getItem('preferences'),this.localStorageService.getItem('roleName'))
      }else{
        const   lastVisitedUrl = this.authService.getLastVisitedUrl();
          this.authService.clearLastVisitedUrl();
          this.router.navigateByUrl(lastVisitedUrl || '/');
      }
    }
    this.removePreviousSearch();
  }

  onSubmit() {
    if (!this.user || !this.user.email) {
      this.showUserNameError = true;
      this.errorMessage = 'Email is required';
      return;
    }

    if (!this.user.email.includes('@')) {
      this.showUserNameError = true;
      this.errorMessage = 'Email Not Found';
      return;
    }

    if (!this.user.password) {
      this.showPasswordError = true;
      this.errorMessage = 'Password is required';
      return;
    }

    this.spinnerService.showSpinner("Logging in...");

    this.authService.login(this.user).subscribe(
      response => {
        this.spinnerService.hideSpinner();
        if (response.status === 'OK') {
          this.authService.saveTokens(response.data,this.rememberMeFlag);
          if(response.data?.accountType=='Staff'){
            this.authService.navigateStaff(response.data?.preferences,response.data?.roleName)
          } else {
            const lastVisitedUrl = this.authService.getLastVisitedUrl();
            this.authService.clearLastVisitedUrl();
            if (localStorage.getItem('postLoginJobApply')) {
              localStorage.removeItem('postLoginJobApply');
            }
            if (lastVisitedUrl && lastVisitedUrl.includes('/webinars/view/')) {
              localStorage.setItem('showWebinarPopup', 'true');
            }
            this.router.navigateByUrl(lastVisitedUrl || '/');
          }

          const profilePhotoObject = {
            url: "https://imgs.search.brave.com/Xdyth7rNTqdKToxvQBZ71Q6KTIqXj6waovokkppRYo0/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9pbWcu/ZnJlZXBpay5jb20v/cHJlbWl1bS1waG90/by8zZC1idXNpbmVz/cy1wZW9wbGVzLXBl/cnNvbi1pY29uXzc0/NTUyOC00NjEyMi5q/cGc"
          };

          let userDetails: UserDetails = {
            userId: response.data?.userId,
            userName: response.data?.userName,
            email: this.user.email,
            role: response.data?.role,
            profilePic: response.data?.profilePic ?? profilePhotoObject.url,
            verified: response.data?.userVerified,
            accountName: response.data?.accountType,
            accessToken: response.data?.accessToken,
            idToken: response.data?.idToken,
            refreshToken: response.data?.refreshToken,
            expiresIn: response.data?.expiresIn,
            preferences:response.data?.preferences,
            status : response.data?.status
          }
          this.localStorageService.updateUserDetails(userDetails);
        } else {
          this.showError = true;
          this.errorMessage = response.error.message;
        }
      },
      (error: any) => {
        this.spinnerService.hideSpinner();
        this.showError = true;
        this.errorMessage = error.error.message;
      }
    );
  }
  onUserNameChange(): void {
    this.showUserNameError = false;
  }

  onPasswordChange(): void {
    this.showPasswordError = false;
  }

  clearError() {
    this.showError = false;
    this.errorMessage = '';
  }

  removePreviousSearch() {
    this.sharedService.setSearchState('', 0, 10);
    sessionStorage.removeItem(this.SEARCH_STORAGE_KEY);
    sessionStorage.removeItem(this.FILTER_STORAGE_KEY);
    sessionStorage.removeItem('activeContent');
    sessionStorage.removeItem('startsWith');
    sessionStorage.removeItem('masterPageSize');
    sessionStorage.removeItem('masterPageIndex');
    sessionStorage.removeItem('productFilter');
    sessionStorage.removeItem('productSearch');
    sessionStorage.removeItem('unitOfMeasureSearch');
    sessionStorage.removeItem('specificationsSearch');
    sessionStorage.removeItem('oemChips');
    sessionStorage.removeItem('oemFilter');
    sessionStorage.removeItem('oemSearch');
    sessionStorage.removeItem('distributorSearch');
    sessionStorage.removeItem('distributorFilter');
    sessionStorage.removeItem('distributorChips')
    sessionStorage.removeItem('distributorPageSize');
    sessionStorage.removeItem('distributorPageIndex');
    sessionStorage.removeItem('endCustomerFilter');
    sessionStorage.removeItem("endCustomerSearch");
    sessionStorage.removeItem("endCustomerPageSize");
    sessionStorage.removeItem("endCustomerPageIndex");
    sessionStorage.removeItem('exhibitionFilter');
    sessionStorage.removeItem('exhibitionSearch');
    sessionStorage.removeItem("webinarsSearch");
    sessionStorage.removeItem('staffSearch');
    sessionStorage.removeItem('staffPageIndex');
    sessionStorage.removeItem('staffPageSize');
    sessionStorage.removeItem('staffFilterData');
    sessionStorage.removeItem('staffFilterChips');
    sessionStorage.removeItem('rolePageIndex');
    sessionStorage.removeItem('rolePageSize');
    sessionStorage.removeItem('roleStatus');
    sessionStorage.removeItem('roleSearch')
    sessionStorage.removeItem('oemPageSize')
    sessionStorage.removeItem('oemPageIndex')
    sessionStorage.removeItem('webinarsPageSize');
    sessionStorage.removeItem('webinarsPageIndex');
    sessionStorage.removeItem('webinarsFilter');
    sessionStorage.removeItem('webinarsChips');
    sessionStorage.removeItem('leadsFilter');
    sessionStorage.removeItem('leadsChips');
    
    this.leadService.updateFilterState({});
    this.leadService.clearFilterState();
    this.leadService.clearSearchState();
  }

}
